<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <!-- <a-form-item :label="this.language['fd.firmsite.dayreporttype']"></a-form-item> -->
            <a-form-item :label="this.language['cs.venuename']">
              <a-input v-model="queryParam.venuename" :placeholder="this.language['cs.venuename']" :maxLength="100"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.venuestatus']">
              <j-multi-select-tag type="select" v-model="queryParam.status" dictCode="cs_venuestatus" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.seatcount']">
              <a-input-number class="query-group-cust" v-model="queryParam.seatCount_min"></a-input-number>
              <span class="query-group-split-cust"></span>
              <a-input-number class="query-group-cust" v-model="queryParam.seatCount_max"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ this.language['common.searchButton']
              }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                this.language['common.resetButton'] }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus" v-has="'cs.venue:add'">新增</a-button> -->
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'venue:add'">新增</a-button>
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel" v-has="'venue:deletebatch'"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{
          selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table ref="table" size="middle" bordered rowKey="sysvenueid" class="j-table-force-nowrap" :scroll="{ x: true }"
        :dataSource="dataSource" :pagination="ipagination" :columns="columns" :loading="loading" :childrenColumnName="0"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEditVenue(record)" v-has="'venue:edit'">{{ language['common.edit'] }}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ language['common.more'] }} <a-icon type="down" /></a>
            <a-menu slot="overlay">

              <a-menu-item>
                <a @click="handleCopy(record)" v-has="'venue:view'">复制</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleDetail(record)" v-has="'venue:view'">{{ language['common.look'] }}</a>
              </a-menu-item>
              <a-menu-item v-has="'venue:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']"
                  @confirm="() => handleDelete(record.sysvenueid)">
                  <a>{{ language['common.delete'] }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <Venue-modal ref="modalForm" @ok="modalFormOk"></Venue-modal>
    <!-- <venue_edit_modal ref="editmodal" @ok="modalFormOk"></venue_edit_modal> -->

    <!--查看圖片-->
    <view-image ref="imgForm"></view-image>

    <!-- :fullscreen="true" -->
    <j-modal ref="VenueEditModal" :title="titleEditForm"  width="100%" :visible="editFormVisible" switchFullscreen
      @ok="handleEditFormOk"  :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }" @cancel="handleEditFormCancel"
      cancelText="关闭">
      <template>
        <VenueEditForm @refreshVenueName="refreshVenueName" :from="'VenueList'" ref="editForm"></VenueEditForm>
      </template>
    </j-modal>

  </a-card>
</template>

<script>
import { httpAction, getAction } from '@/api/manageChooseSeat'
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
import { initDictOptions,filterDictText } from '@/components/dict/JDictSelectUtil'
import { getDictItemsFromCache } from '@/api/api'
import VenueModal from './modules/VenueModal.vue'
import VenueEditForm from './modules/VenueEditForm.vue'

export default {
  name: "VenueList",
  mixins: [JeecgListMixin],
  components: {
    VenueModal,
    VenueEditForm
  },
  data() {
    return {
      description: '场馆列表',

      url: {
        list: "/VenueInfo/list",
        delete: "/VenueInfo/delete",
        deleteBatch: "/VenueInfo/deleteBatch",
        copy: "/VenueInfo/CopyData"

      },
      model: {

      },

      confirmLoading: false,
      selectDataSiteList: [],
      selectDataAreaCodeList: [],
      title: '',
      operation: {
        optiontype: "add",
        disible: false
      },
      width: 800,
      visible: false,

      //编辑窗设置
      titleEditForm:'',
      editFormVisible:false,

      venuestatus:[],
      venuecategory:[],


    }
  },
  provide() {
    return {
      operation: this.operation,
    }
  },
  created() {
    initDictConfig();
  },
  mounted() {
    // getFactoryList().then(res => {
    //   this.selectDataAreaCodeList = res;
    // })
  },
  computed: {
    language() {
      return this.$store.getters.language
    },

    columns() {
      if (this.language) {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          //場館名稱
          {
            title: this.language['cs.venuename'],
            align: "left",
            ellipsis: true,
            dataIndex: 'venuename'
          },
          //狀態
          {
            title: this.language['cs.venuestatus'],
            ellipsis: true,
            width: 150,
            align: "left",
            dataIndex: 'status',
            customRender: (text, row, index) => {
              return filterDictText(this.venuestatus,text)
            }
          },
          //場館性質
          {
            title: this.language['cs.venuecategory'],
            align: "left",
            ellipsis: true,
            dataIndex: 'category',
            width: 150,
            customRender: (text, row, index) => {
              return filterDictText(this.venuecategory,text)
            }
          },
          //場館樓層數
          {
            title: this.language['cs.floorCount'],
            width: 100,
            align: "left",
            dataIndex: 'floorCount',
            ellipsis: true
          },

          //區域個數
          {
            title: this.language['cs.areacount'],
            width: 100,
            align: "left",
            ellipsis: true,
            dataIndex: 'areaCount'
          },
          //座位總數
          {
            title: this.language['cs.seat.seattotalqty'],
            width: 100,
            align: "left",
            dataIndex: 'seatCount',
            ellipsis: true

          },
          //詳細地址
          {
            title: this.language['labor.contractor.detailAddress'],
            width: 100,
            align: "left",
            ellipsis: true,
            dataIndex: 'address',

          },
          //創建人
          {
            title: this.language['common.creator'],
            align: "center",
            width: 150,
            dataIndex: 'creator'
          },
          //創建時間
          {
            title: this.language['common.createTime'],
            align: "center",
            width: 150,
            dataIndex: 'createdate'
          },
          //修改人
          {
            title: this.language['common.modifier'],
            align: "center",
            width: 150,
            dataIndex: 'modifier'
          },
          //修改時間
          {
            title: this.language['common.modifyTime'],
            align: "center",
            width: 150,
            dataIndex: 'modifydate'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ]
      }
    }
  },
  methods: {
    initDictConfig() {

      var that=this;
      initDictOptions('cs_venuestatus').then((res) => {
                    if (res.success) {
                      that.venuestatus= res.result;
                    }
                });
      initDictOptions('cs_venuecategory').then((res) => {
                    if (res.success) {
                      that.venuecategory =  res.result;
                    }
                });
    },

    searchQuery() {
      if (this.queryParam.areacodelist != null) {
        this.queryParam.areacode = this.queryParam.areacodelist.join(',');
      }
      this.loadData(1);
    },
    handleAdd: function () {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "場館信息";
      this.operation.optiontype = "add";
      this.operation.disible = true;
      this.$refs.modalForm.disableSubmit = false;
    },

    handleDetail: function (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "详情";
      this.$refs.modalForm.disableSubmit = true;
      this.operation.optiontype = "view";
      if (record.recordtype == "A") {
        this.operation.disible = true;
      }
      else {
        this.operation.disible = false;
      }
    },
    handleEditVenue: function (record) {
      this.titleEditForm=record.venuename;
      this.operation.sysvenueid=record.sysvenueid;
      this.operation.record=record;
      this.editFormVisible=true;
    },
    handleImgView(img) {
      // this.$refs.imgForm.viewimage(img);
    },

    handleEditFormOk()
    {
      this.editFormVisible=false;
    },
    handleEditFormCancel()
    {
      this.editFormVisible=false;
    },
    refreshVenueName(name)
    {
      this.titleEditForm=name;
      this.searchQuery();
    },
    handleCopy(record)
    {
      httpAction(this.url.copy,{sysvenueid:record.sysvenueid},  'post').then((res) => {
        if (res.success) {
          //重新计算分页问题
          this.loadData(1);
          this.$message.success(res.message);

        } else {
          this.$message.warning(res.message);
        }
      });

    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>